export const MATERIALS_KEYS = {
  DELETE: "materials-materials-delete",
  CREATE: "materials-materials-create",
  UPDATE: "materials-materials-update",
  RECORDS: "materials-materials",
};
